import React, { useState } from 'react'
import { Paper, AppBar, Tabs, Tab } from '@material-ui/core'
import styled from 'styled-components'

import { CardTemplateDb } from '../redux/cardTemplateDbSlice';
import DesignTemplate from './DesignTemplate'
import EditTemplateCode from './EditTemplateCode'
import TabPanel from '../components/TabPanel'
import { EditTemplateAttributeDbHashType, EditTemplateShapeDbHashType } from '../components/EditTemplateDialog';

const TabsAppBar = styled(AppBar)`
  color: black;
  background-color: white;
`

const a11yProps = (index: any) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

type EditTemplateCardProps = {
  id: string
  template: CardTemplateDb
  setTemplate: (template: CardTemplateDb) => void
  attributes: EditTemplateAttributeDbHashType;
  setAttributes: (items: EditTemplateAttributeDbHashType) => void;
  shapes: EditTemplateShapeDbHashType;
  setShapes: (shapes: EditTemplateShapeDbHashType) => void;
  splitUpdated: boolean;
}
const EditTemplateCard: React.FC<EditTemplateCardProps> = ({id, template, setTemplate, attributes, setAttributes, shapes, setShapes, splitUpdated}) => {
  const [value, setValue] = useState(0)
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue)
  }

  return (
    <Paper>
        {/* <TabsAppBar position="static" elevation={0}>
          <Tabs value={value} onChange={handleChange} variant="fullWidth">
            <Tab label="デザイン" {...a11yProps(0)} />
            <Tab label="コードテンプレート" {...a11yProps(1)} />
          </Tabs>
        </TabsAppBar>
        <TabPanel value={value} index={0}> */}
          <DesignTemplate templateId={id} template={template} setTemplate={setTemplate}
            attributes={attributes} setAttributes={setAttributes}
            shapes={shapes} setShapes={setShapes}
            splitUpdated={splitUpdated}
          />
        {/* </TabPanel>
        <TabPanel value={value} index={1}>
          <EditTemplateCode template={template} setTemplate={setTemplate}/>
        </TabPanel> */}
    </Paper> 
  )
}

export default EditTemplateCard;
